var Filters;

(function($){

    Filters = {

        $ : null,
        list : {},
        search : {},
        filter : {},
        $search : null,
        $searchClear : null,
        $drops : null,
        $list : null,
        $modal : null,
        $modalSlider : null,
        $modalClose : null,
        initialkeyword : null,

        init : function(){

            this.$ = $( '.lista-conteudo' );
            if( !this.$.length ) return true;

            Filters.configure();
        
        },

        configure : function(){

            // General
            this.$form = $( 'form.filters', this.$ );

            // Search
            this.$search = $( 'fieldset.search', this.$ );
            this.$keyword = $( 'input[name="buscar-por"]', this.$search );
            this.$submit = $( 'button[data-action="search"]', this.$search );
            this.$clear = $( 'button[data-action="reset"]', this.$search );
            
            // Filters
            this.$filter = $( 'fieldset.filter', this.$ );
            this.$checksTipos = $( '.tipo-de-midia input[type="checkbox"]', this.$filter );
            this.$tipos = $( 'input[name="tipo-de-midia"]', this.$filter );
            this.$drops = $( '.dropdown input', this.$filter );

            // List
            this.$list = $( '.list-teasers', this.$ );
            this.$pager = $( '.paginationjs', this.$ );

            // Form submit
            this.$form.on( 'submit.Filters', function(e){

                var doSubmit = Filters.$form.data( 'doSubmit' );
                if( doSubmit !== undefined && doSubmit === true ){
                    return true;
                }
                else {
                    e.preventDefault();
                    Filters.submit();
                }
            
            });

            // Binders
            this.bindSearch();
            this.bindFilters();

            // Scrolling
            var qString = document.location.href.split( '?' );
            if( qString.length >= 2 ){
                var $target = $( '[data-key="search-content"]' );
                //window.scroll( 0, parseInt( $target.offset().top ) );
                Utils.scrollTo( $target );
            }

        },

        // Search
        bindSearch : function(){

            // Initial keyword
            this.initialkeyword = this.$keyword.val();

            this.$keyword.on( 'focus', function(){

                Filters.$search.removeClass( 'empty filled' );

                if( Filters.$keyword.val() === '' ){
                    Filters.$search.addClass( 'empty' );
                }
                else {
                    Filters.$search.addClass( 'filled' );
                }
            
            });

            this.$keyword.on( 'keyup', function(){

                Filters.$search.removeClass( 'empty filled clearable' );

                var value = Filters.$keyword.val();
                if( value === '' ){

                    Filters.$search.addClass( 'empty' );
                
                }
                else {

                    Filters.$search.addClass( 'filled' );

                    if( value !== '' && value === Filters.initialkeyword ){
                        Filters.$search.addClass( 'clearable' );
                    }
                
                }
            
            });

            this.$clear.on( 'click', function(e){
                
                e.preventDefault();
                
                Filters.$keyword.val( '' ).trigger( 'keyup' );

                if( window.location.href.toString().indexOf( '?buscar-por=' ) > -1 ){
                    Filters.submit();
                }
            
            });

            // this.$searchClear.on( 'click', function(e){
            //     Filters.$search.removeClass( 'filled clearable' ).addClass( 'empty' );
            //     Filters.$keyword.val('').focus();
            //     Filters.submit();
            // });

        },

        // Filter
        bindFilters : function(){
            
            var $this = $( '.filters', this.$ );

            // On drops change
            this.$drops.on( 'change', function(){
                Filters.submit();
            });
            // On checkbox change
            this.$checksTipos.on( 'change', function(){
                Filters.submit();
            });

        },

        cleanFilters : function(){

            this.filter.$checks.filter( ':checked' ).each(function(){
            
                this.$ = this.$ || $( this );
                this.$.prop( 'checked', false ).removeAttr( 'checked' );

                // Remove actove
                Filters.unckeckFilter( this );
            
            });
                
            Filters.submit();

        },

        setFilterValues : function( callback ){

            Loader();

            var tipos = [];
            this.$checksTipos.filter( ':checked' ).each(function(){
                this.$ = this.$ || $( this );
                tipos.push( this.$.val() );
            });
            this.$tipos.val( tipos.length ? tipos.join( ',' ) : '' );

            if( callback !== undefined ){
                callback();
            }

        },

        submit : function(){

            Loader();

            Filters.setFilterValues(function(){

                // Remove empty fields
                $( 'input,select', Filters.$ ).each(function(){
                    this.$ = this.$ || $( this );
                    if( this.$.val() == '' ){
                        this.$.removeAttr( 'name' );
                    }
                });

                Filters.$form
                    .off( 'submit.Filters' )
                    .data( 'doSubmit', true )
                    .submit()
                ;
                 
           });

        },

        receiveRequest : function( response ){

            // Check filters
            Loader( 'close' );
                
            var $page = $( '<div>' + response + '</div>' );
            
            // To insert
            var $toInsert = $page.find( '.mosaic-images' ).children( 'div' );
            if( !$toInsert.length ){
                $toInsert = $( '<div class="no-results"><span class="inner">Não encontramos um match perfeito ao que você procura.</span></div>' );
            }

            // Remove actuals
            var $actuals = this.$list.children( 'div' );
            $actuals.removeClass( 'inserted show' ).addClass( 'removing' );

            // Wait remove animation
            setTimeout(function(){
               
                // Remove actuals
                $actuals.remove();

                // Inser news
                $toInsert.addClass( 'inserted' ).appendTo( Filters.$list );
                setTimeout(function(){
                    $toInsert.addClass( 'show' );
                }, 10 );
            
            }, 300 );
            
            natura.loaderHide();
    
        }

    };
    $(function(){ 
        Filters.init(); 
    });

})(jQuery);
